export default __webpack_public_path__ + "4fda88c201b7b656a1d3ccbe91bc5e92.png";